import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Container, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Divider, Snackbar } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Alert } from '@material-ui/lab';
import TableProduit from './TableProduit';
import TableStock from './TableStock';
import TreeClient from '../../treeClient';
import Axios from 'axios';
import { apiATC } from '../../../config';
import useReservationStyles from './reservationStyles';

const ReservationCollection = () => {
    const classes = useReservationStyles();
    const [client, setClient] = useState(null);
    const [produitSelectionne, setProduitSelectionne] = useState(null);
    const [stockSelectionne, setStockSelectionne] = useState(null);
    const [commandeOf, setCommandeOf] = useState(null); // OF choisi via autocomplete commande
    const [stockOf, setStockOf] = useState(null); // OF choisi via autocomplete stock
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState('');
    const [pendingAction, setPendingAction] = useState(null);
    const [commande, setCommande] = useState([]);
    const [stock, setStock] = useState([]);
    const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });

    useEffect(() => {
        afficher();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const afficher = () => {
        const params = { client };
        Axios.post(`${apiATC}/produit/operation_stock.php?action=reservation`, params)
            .then(({ data: { commande, stock } }) => {
                // Vérifier si les données commande et stock sont présentes
                if (!commande || !stock) {
                    // Gérer le cas où les données sont manquantes
                    console.error("Données de commande ou de stock manquantes");
                    return;
                }

                const updatedCommande = [];
                commande.forEach(cmd => {
                    const stockElement = stock.find(stk =>
                        stk.idp === cmd.idp && stk.type_metal === cmd.type_metal
                    );
                    const dejaReserve = stockElement && stockElement.client_reserve ? true : false;
                    updatedCommande.push({ ...cmd, dejaReserve });
                });

                setCommande(updatedCommande);

                setStock(stock);
                setProduitSelectionne(null)
            })
            .catch(error => {
                // Gérer les erreurs de la requête Axios
                console.error("Une erreur s'est produite lors de la récupération des données:", error);
            });
    };




    const onRowClickProduit = (data) => {
        setProduitSelectionne(data);
    }
    const onRowClickStock = (data) => {
        setStockSelectionne(data)
    }
    const handleChangeClient = (data) => {
        setClient(data);
    };

    const modifierReservation = (type, source = 'TABLE', stockOverride = null, prodOverride = null, { skipWarning = false } = {}) => {
        try {
            const prodSel = prodOverride || (source === 'FORM' ? commande.find(c => c.of === (commandeOf && commandeOf.of)) : produitSelectionne);
            const stockSel = stockOverride || (source === 'FORM' ? stock.find(s => s.of === (stockOf && stockOf.of)) : stockSelectionne);

            if ((type === 'AJOUTER' && (!prodSel || !stockSel)) ||
                (type === 'DERESERVER' && !stockSel)) return Promise.resolve();

            if (type === 'AJOUTER' && !skipWarning) {
                const warnings = [];
                if (Number(prodSel.of_reservation) !== 0) {
                    warnings.push(`L'OF commande ${prodSel.of} est déjà lié à une réservation (${prodSel.of_reservation}).`);
                }
                if (stockSel.client_reserve) {
                    warnings.push(`L'OF stock ${stockSel.of} est déjà réservé par ${stockSel.client_reserve}.`);
                }
                if (warnings.length) {
                    setConfirmMessage(warnings.join('\n') + '\nConfirmer quand même ?');
                    setPendingAction({ type, prodSel, stockSel, source });
                    setConfirmOpen(true);
                    return Promise.resolve();
                }
            }

            const verif = {
                table: 'of',
                primaryKey: 'of_reservation',
                id: stockSel.of,
                of_reservation: 0,
            };
            const form = {
                table: 'of',
                primaryKey: type === 'AJOUTER' ? 'num_sachet' : 'of_reservation',
                id: type === 'AJOUTER' ? prodSel.of : stockSel.of,
                of_reservation: type === 'AJOUTER' ? stockSel.of : 0,
            };

            return Axios.post(`${apiATC}/general.php?action=modifier`, verif)
                .then(() => Axios.post(`${apiATC}/general.php?action=modifier`, form))
                .then(() => {
                    setSnack({ open: true, message: type === 'AJOUTER' ? 'Réservation enregistrée' : 'Déréservation effectuée', severity: 'success' });
                    afficher();
                    if (source === 'FORM') {
                        setCommandeOf(null);
                        setStockOf(null);
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de la mise à jour du statut:', error);
                    setSnack({ open: true, message: 'Erreur lors de la mise à jour', severity: 'error' });
                });
        } catch (error) {
            console.error('Erreur inattendue:', error);
            return Promise.reject(error);
        }
    };

    const isReservationPossible = produitSelectionne && stockSelectionne && !stockSelectionne.client_reserve;
    const isDereservationPossible = stockSelectionne && stockSelectionne.client_reserve;

    const commandeOptions = commande.map(c => ({ of: c.of, label: `${c.of} - ${c.metal} - ${c.ref} - ${c.designation}`, of_reservation: c.of_reservation }));
    const stockOptions = stock.map(s => ({ of: s.of, label: `${s.of} - ${s.metal} - ${s.ref} - ${s.designation}`, client_reserve: s.client_reserve }));

    const handleFormSubmit = () => {
        modifierReservation('AJOUTER', 'FORM');
    };

    // Refs pour gestion Enter
    const stockAutoRef = useRef();

    const handleAutoKeyDown = (e, type) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (type === 'commande') {
                if (!commandeOf && commandeOptions.length > 0) setCommandeOf(commandeOptions[0]);
                // focus suivant
                setTimeout(() => stockAutoRef.current?.querySelector('input')?.focus(), 0);
            } else if (type === 'stock') {
                if (!stockOf && stockOptions.length > 0) setStockOf(stockOptions[0]);
                // soumettre si les deux sont présents
                setTimeout(() => {
                    if (commandeOf && (stockOf || stockOptions[0])) handleFormSubmit();
                }, 0);
            }
        }
    };

    return (
        <>
            <Container maxWidth={false} className={classes.root}>
                <Box className={classes.content}>
                    {/* Tables dans leurs propres colonnes de la grille */}
                    <Box className={classes.tableCard}>
                        <TableProduit data={commande} onRowClick={onRowClickProduit} />
                    </Box>
                    <Box className={classes.tableCard}>
                        <TableStock data={stock} onRowClick={onRowClickStock} filtreProduit={produitSelectionne} />
                    </Box>
                    {/* Panneau latéral dans sa propre colonne */}
                    <Box className={classes.sidePanel}>
                        <Box className={classes.actionsPanel}>
                            <Typography className={classes.actionsTitle}>Réservations OF</Typography>
                            <TreeClient handleChange={handleChangeClient} />
                            <Divider className={classes.dividerThin} />
                            <Button onClick={afficher} variant="contained" color="primary" className={classes.actionBtn}>Actualiser</Button>
                            <Button disabled={!isDereservationPossible} onClick={() => modifierReservation('DERESERVER')} variant="contained" color="secondary" className={classes.actionBtn}>Dé-réserver</Button>
                            <Button disabled={!isReservationPossible} onClick={() => modifierReservation('AJOUTER')} variant="contained" color="primary" className={classes.actionBtn}>Réserver</Button>
                            <Divider className={classes.dividerThin} />
                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginTop: 4, textAlign:'center' }}>Formulaire rapide</Typography>
                            <Box display="flex" flexDirection="column" gridGap={6} style={{ marginBottom: 2, alignItems:'stretch' }}>
                                <Autocomplete
                                    value={commandeOf}
                                    onChange={(_, val) => setCommandeOf(val)}
                                    options={commandeOptions}
                                    getOptionLabel={(o) => o.label}
                                    renderOption={(option) => (
                                        <div className={option.of_reservation ? classes.optionWarning : classes.optionOk}>
                                            <span>{option.label}</span>
                                            {option.of_reservation ? <span className={classes.badgeInline}>déjà liée</span> : null}
                                        </div>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Commande" variant="outlined" size="small" className={classes.roundedField}
                                            onKeyDown={(e) => handleAutoKeyDown(e, 'commande')} />
                                    )}
                                    disableClearable openOnFocus
                                />
                                <Autocomplete
                                    value={stockOf}
                                    onChange={(_, val) => setStockOf(val)}
                                    options={stockOptions}
                                    getOptionLabel={(o) => o.label}
                                    renderOption={(option) => (
                                        <div className={option.client_reserve ? classes.optionWarning : classes.optionOk}>
                                            <span>{option.label}</span>
                                            {option.client_reserve ? <span className={classes.badgeInline}>réservé</span> : null}
                                        </div>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Stock" variant="outlined" size="small" className={classes.roundedField}
                                            onKeyDown={(e) => handleAutoKeyDown(e, 'stock')} />
                                    )}
                                    disableClearable openOnFocus ref={stockAutoRef}
                                />
                                <Box display="flex" justifyContent="center" gridGap={8}>
                                    <Button variant="contained" color="primary" disabled={!commandeOf || !stockOf} onClick={handleFormSubmit} size="small">Enregistrer</Button>
                                    <Button size="small" onClick={() => { setCommandeOf(null); setStockOf(null); }}>Reset</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                    <DialogTitle>Confirmation</DialogTitle>
                    <DialogContent style={{ whiteSpace: 'pre-line' }}>{confirmMessage}</DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setConfirmOpen(false); setPendingAction(null); }} color="default">Annuler</Button>
                        <Button onClick={async () => {
                            if (pendingAction) {
                                const { prodSel, stockSel, source } = pendingAction;
                                setConfirmOpen(false);
                                setPendingAction(null);

                                const ops = [];
                                const handledStockIds = new Set();
                                // Si l'OF commande avait déjà une réservation, libérer l'ancien stock (of = prodSel.of_reservation)
                                if (Number(prodSel.of_reservation) !== 0) {
                                    const prevStock = stock.find(s => s.of === prodSel.of_reservation);
                                    if (prevStock) {
                                        handledStockIds.add(prevStock.of);
                                        ops.push(() => modifierReservation('DERESERVER', source, prevStock, null, { skipWarning: true }));
                                    }
                                }
                                // Exécuter séquentiellement
                                for (const op of ops) {
                                    // eslint-disable-next-line no-await-in-loop
                                    await op();
                                }
                                // Enfin créer la nouvelle réservation sans re-générer l'alerte
                                await modifierReservation('AJOUTER', source, stockSel, prodSel, { skipWarning: true });
                            }
                        }} color="primary" autoFocus>Continuer</Button>
                    </DialogActions>
                </Dialog>
            </Container>
            <Snackbar
                open={snack.open}
                autoHideDuration={3000}
                onClose={() => setSnack(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert elevation={6} variant="filled" severity={snack.severity} onClose={() => setSnack(s => ({ ...s, open: false }))}>{snack.message}</Alert>
            </Snackbar>
        </>
    );
};

export default ReservationCollection;